<template>
  <div id="app">
    <nav>
      <tab-header></tab-header>
    </nav>
    <div class="every-content">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped></style>
<style lang="less">
nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10 !important;
}
#app {
  margin: auto;
  position: relative;
  z-index: 100;
}
.content-header {
  position: absolute;
  z-index: 10;
}
.every-content {
  min-height: calc(100vh - 96px);
  margin-top: 96px;
  background: linear-gradient(rgba(243, 247, 255), rgba(245, 247, 249));
}
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 4px;
  /* 滚动条宽度 */
  /* 滚动条高度（对于水平滚动条） */
}

/* 滚动条轨道的样式 */
::-webkit-scrollbar-track {
  opacity: 0.06;
  background: #f2f9fd;
  /* 轨道颜色 */
  border-radius: 20px;
  position: absolute;
  right: 0;
  /* 轨道圆角 */
}

/* 滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
  opacity: 0.5;
  background: #99d3ff;
  border-radius: 2px;
  position: absolute;
  right: 0;
  /* 滑块圆角 */
  /* 添加过渡效果 */
  transition: background-color 0.3s;
}

/* 当鼠标悬停在滑块上时改变滑块颜色 */
::-webkit-scrollbar-thumb:hover {
  background: #008af4;
  /* 滑块颜色（悬停状态） */
}
</style>

<script>
import TabHeader from "./views/components/TabHeader.vue";
export default {
  data() {
    return {};
  },
  components: {
    TabHeader,
  },
};
</script>
